/*
 * @Author: 刘洪壮 liuhongzhuang@nextmar.com
 * @Date: 2025-06-23 16:36:03
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2025-09-08 17:47:23
 * @FilePath: /src/app/(payment)/payment/components/ShippingMethod/index.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { Address } from '@/api/types/public';
import Radio from '@/components/Form/Radio';

import { IPrice } from '@/api/types/order';
import Image from '@/components/Image';
import { useStore } from '@/providers/app-store-provider';
import { formatPriceNumberWithSymbol } from '@/utils/price';
import { isEmpty } from '@/utils/tools';
import { SuccessFilled } from '@zeelool/icon';
import { useTranslations } from 'next-intl';
import { useEffect, useMemo, useState } from 'react';
import { useForm } from 'react-hook-form';
interface ShippingMethodProps {
  freightList: IPrice['freight'];
  isPobox: boolean;
  isVip: boolean;
  isMobile: boolean;
  address?: Address;
  changeShippingMethod: (shippingMethod: string, type?: boolean) => void;
  onTrackEvent: (btn_name: string) => void;
}

// 定义运输方式的优先级顺序
const SHIPPING_METHOD_ORDER = {
  ordinary: 1,
  advanced: 2,
  business: 3,
};

const SHIPPING_METHOD_NAME = {
  ordinary: 'ordinary',
  advanced: 'advanced',
  business: 'business',
};

export default function ShippingMethod({
  freightList,
  isPobox,
  isVip,
  changeShippingMethod,
  address,
  onTrackEvent,
  isMobile,
}: ShippingMethodProps) {
  const t = useTranslations('payment.ShippingMethod');
  const { control } = useForm();
  const [shippingMethod, setShippingMethod] = useState<string>('');
  const [showTipsWords, setShowTipsWords] = useState<string>('');
  const [business, setBusiness] = useState<any>(null);

  const currency = useStore((state) => state.currency);

  const freeThreshold = (priceInfo: IPrice['freight'][number]['price_info']) => {
    if (!isEmpty(priceInfo)) {
      const currentPrice = priceInfo.find((item) => item.currency === currency.name);
      return currentPrice?.price;
    } else {
      return '';
    }
  };
  const SHIPPING_METHOD_LABEL = {
    ordinary: t('ordinary'),
    advanced: t('advanced'),
    business: t('business'),
  };

  const getShowTipsWords = () => {
    let word = t('recommend');
    try {
      const chooseItem = freightList.find((ite) => ite.name === shippingMethod);
      const recommendItem = freightList.find((ite) => ite.recommend);
      const time = chooseItem?.time_max - recommendItem?.time_max;

      if (shippingMethod === '') {
        word = t('recommend');
      } else if (time > 0) {
        word = `${time}${time > 1 ? t('days') : t('day')} ${t('faster')}`;
      } else {
        word = t('recommend');
      }
      return word;
    } catch {
      return word;
    }
  };

  useEffect(() => {
    setShowTipsWords(getShowTipsWords());
  }, [shippingMethod, freightList]);

  useEffect(() => {
    const _business = freightList.find((item) => item.name === 'business');
    setBusiness(_business);
    if (!isPobox) {
      const freightType = freightList.find((item) => item.default)?.name || '';
      setShippingMethod(freightType);
      changeShippingMethod(freightType);
    }
  }, []);

  useEffect(() => {
    // TODO 后面改版时在这里增加一下判断，如果选中物流项 forbidden === 1 则清空，这样后端再增加其他禁用条件前端就不需要改代码。
    // 当前没有问题，就先不增加这个判断
    if (isPobox && shippingMethod === 'business') {
      setShippingMethod('');
      changeShippingMethod('');
    }
  }, [isPobox, shippingMethod]);

  const freightListKey = useMemo(() => {
    return JSON.stringify(freightList);
  }, [freightList]);

  useEffect(() => {
    if (!address?.id) return;

    const _business = freightList.find((item) => item.name === 'business');
    setBusiness(_business || {});

    const defaultAddress = freightList.find((item) => item.default === 1);
    if (defaultAddress) {
      setShippingMethod(defaultAddress?.name || '');
      changeShippingMethod(defaultAddress?.name || '');
      // 如果当前地址为box地址，并且默认物流为business，需要把当前选中的物流清除
      if (isPobox && defaultAddress?.name === 'business') {
        setShippingMethod('');
        changeShippingMethod('');
      }
    } else {
      setShippingMethod('');
      changeShippingMethod('');
    }
  }, [address?.id, freightListKey]);

  const renderLabel = (
    item: IPrice['freight'][number] & { free_threshold_price_info: any; origin_price: string },
  ) => {
    return (
      <div className={`w-full`}>
        <div className="flex justify-between">
          <div className="name">
            <div className="flex items-center md:flex-wrap">
              <div className="font-bb  mr-4 text-[14px] whitespace-nowrap ">
                {item.time_min}-{item.time_max} {t('days')}
              </div>
              {[2, 3].includes(item.freight_discount_type) &&
                [SHIPPING_METHOD_NAME.ordinary, SHIPPING_METHOD_NAME.advanced].includes(
                  item.name,
                ) && (
                  <div className="h-[18px] rounded-[4px] text-xs leading-[12px] text-white px-[6px] py-[3px] whitespace-nowrap inline-block box-border mr-[5px] bg-[#ffb801]">
                    {t('over')}{' '}
                    {formatPriceNumberWithSymbol(
                      freeThreshold(item.free_threshold_price_info),
                      currency,
                    )}{' '}
                    {t('free')}
                  </div>
                )}
              {item.freight_discount_type === 4 && (
                <div className="h-[18px] rounded-[4px] text-xs leading-[12px] text-white px-[6px] py-[3px] whitespace-nowrap inline-block box-border mr-[5px] bg-[#00C191]">
                  {t('shippingCoupon')}
                </div>
              )}
              {item.recommend > 0 && (
                <div className="text-[#299373]  bg-[#d7e8e3] text-[12px] p-2 py-0 rounded-4 mr-20">
                  {showTipsWords}
                </div>
              )}
            </div>

            <div
              className={`mt-[4px] flex justify-start items-center gap-4 flex-row flex-wrap 2xl:flex-row 2xl:items-center`}
            >
              <div className=" text-[12px]">{SHIPPING_METHOD_LABEL[item.name]}</div>
              {(item.name === SHIPPING_METHOD_NAME.business && item.freight_discount_type === 3 && (
                <Image src="/payment/zing-new.png" alt="" width={100} height={20} />
              )) ||
                (isVip &&
                  item.freight_discount_type === 1 &&
                  item.name === SHIPPING_METHOD_NAME.business && (
                    <Image
                      src="/payment/zing-new.png"
                      alt=""
                      width={100}
                      height={20}
                      className="mt-4"
                    />
                  ))}
            </div>
          </div>
          <div className="flex flex-col items-end justify-center">
            <div className="font-bb text-[14px] whitespace-nowrap">
              {formatPriceNumberWithSymbol(item.price, currency)}
            </div>
            {item.price !== item.origin_price && (
              <div className="text-[#999] text-[12px] leading-[14px]  line-through">
                {formatPriceNumberWithSymbol(item.origin_price, currency)}
              </div>
            )}
          </div>
        </div>
        {item.name === SHIPPING_METHOD_NAME.business && (
          <div
            className={`text-[12px] font-br  leading-[16px] mt-[6px] ${
              isPobox ? 'text-error' : 'text-secondary-text'
            }`}
          >
            {t('noPOBoxDelivery')}
          </div>
        )}

        {isVip &&
          item.name === SHIPPING_METHOD_NAME.business &&
          shippingMethod === SHIPPING_METHOD_NAME.business &&
          business?.left_free &&
          !business?.freight_discount_code && (
            <div className="text-[12px] md:text-[14px] font-br  text-warning mt-[10px] leading-[14px]">
              {t('buy')}{' '}
              <span className="notranslate">
                {formatPriceNumberWithSymbol(business.left_free, currency)}
              </span>{' '}
              {t('moreToEnjoyFreeExpressShipping')}
            </div>
          )}
      </div>
    );
  };

  // 使用useMemo对运输方式列表进行排序
  const sortedFreightList = useMemo(() => {
    return [...freightList].sort((a, b) => {
      const orderA = SHIPPING_METHOD_ORDER[a.name.toLowerCase()] || 999;
      const orderB = SHIPPING_METHOD_ORDER[b.name.toLowerCase()] || 999;
      return orderA - orderB;
    });
  }, [freightList]);
  return (
    <div className="mt-10 w-full md:w-5/9">
      {sortedFreightList.length > 0 &&
        address?.id &&
        sortedFreightList.map((item) => (
          <div
            key={item.name}
            className={`flex flex-col w-full box-border min-h-[72px] bg-[#f5f6f7] md:bg-white  border-0 md:border-1  border-[#DDDDDD] rounded-[5px] mb-[15px] last:mb-0  mr-0  relative overflow-hidden ${
              shippingMethod === item.name
                ? ' !border-1 md:!border-2  !border-[#463ae8] md:!bg-[#e5ebfe]'
                : ''
            }`}
          >
            <Radio
              name="shippingMethod"
              control={control}
              value={item.name}
              labelPlacement={isMobile ? 'start' : 'end'}
              disabled={item.forbidden === 1}
              label={renderLabel(item as any)}
              onChange={(e) => {
                const { value } = e.target;
                setShippingMethod(value);
                changeShippingMethod(value, true);
                onTrackEvent(value);
              }}
              checkedIcon={<SuccessFilled className="text-[20px] text-[#463AE8]" />}
              checked={shippingMethod === item.name}
              sx={{
                width: '100%',
                margin: 0,
                padding: isMobile ? '16px 6px' : '16px 20px',
                '& .MuiRadio-root': {
                  padding: 0,
                },
                '& .MuiTypography-root': {
                  marginLeft: {
                    md: '16px',
                  },
                },
                '& .MuiFormControlLabel-label': {
                  width: '100%',
                  flexGrow: 1,
                  paddingRight: isMobile ? '8px' : '0',
                },
                '&.Mui-disabled': {
                  cursor: 'not-allowed',
                },
                // 移动端 Radio 按钮尺寸设置为34px
                ...(isMobile && {
                  '& .MuiRadio-root': {
                    width: '20px',
                    height: '20px',
                    padding: 0,
                  },
                }),
              }}
            />
          </div>
        ))}

      {!address?.id && (
        <div className="text-center text-secondary-text leading-[2] text-[14px] py-[20px]">
          {t('pleaseAddShippingAddress')}
        </div>
      )}
    </div>
  );
}
